import { render, staticRenderFns } from "./No-Data.vue?vue&type=template&id=f56722a4&scoped=true&lang=pug"
import script from "./No-Data.vue?vue&type=script&lang=js"
export * from "./No-Data.vue?vue&type=script&lang=js"
import style0 from "./No-Data.vue?vue&type=style&index=0&id=f56722a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56722a4",
  null
  
)

export default component.exports